import { formatDate } from '../../pages/Invoices/InvoiceHub/utils';
import { isBillOverdue } from '../../pages/BillPay/features/BillsHub/utils';
import { BILLS_STATUSES } from '../../pages/BillPay/consts';

export const getDueDateNoticeTextStyle = (status: string) => {
  if (status === BILLS_STATUSES.PENDING || status === BILLS_STATUSES.AWAITING_DETAILS) return 'leading-[14px] text-sm text-red02';
  if (status === BILLS_STATUSES.PAID) return 'text-sm text-badgeGreen02';
  return '';
};
export const getDueDateNoticeText = (status: string, numOfOverdueDays: number, t: any, paidTime?: string) => {
  if (isBillOverdue(status, numOfOverdueDays)) {
    const resource = numOfOverdueDays > 1 ? 'DUE_DATE_NOTICE.DAYS_OVERDUE' : 'DUE_DATE_NOTICE.DAY_OVERDUE';
    return `${numOfOverdueDays} ${t(resource)}`;
  }
  if (status === BILLS_STATUSES.PAID) return formatDate(paidTime, false);
  return '';
};
